import React, { useEffect } from 'react';

const GmailCallback = () => {
  useEffect(() => {
    // Extract authorization code from URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      // Send error to parent window
      window.opener.postMessage({
        type: 'GMAIL_OAUTH_ERROR',
        error: error
      }, window.location.origin);
      window.close();
    } else if (code) {
      // Send success with code to parent window
      window.opener.postMessage({
        type: 'GMAIL_OAUTH_SUCCESS',
        code: code
      }, window.location.origin);
      window.close();
    } else {
      // No code or error, close window
      window.close();
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Processing Gmail Authorization...</h2>
        <p>Please wait while we complete the authorization process.</p>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #039772b0',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '20px auto'
        }}></div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default GmailCallback;
